import { createAction } from 'redux-actions'

export const SET_SOURCE_INTEGRATIONS_SETTINGS = 'SET_SOURCE_INTEGRATIONS_SETTINGS'
export const setSourceIntegrationsSettings = createAction(SET_SOURCE_INTEGRATIONS_SETTINGS)



// WEBPACK FOOTER //
// ./actions/source-integrations.js